'use client';

import type { Life, Note, Post } from 'content-collections';

import { Input, Label } from '@mcdougald/ui/src';
import { countBy } from 'lodash';
import { SearchIcon } from 'lucide-react';
import { useState } from 'react';

import { RenderPostsTags } from '@/components/posts/render-posts-tags';

import PostCards from './post-cards';

type FilteredPostsProps = {
  posts: Post[];
  notes: Note[];
  lifeUpdates: Life[];
};

const FilteredPosts = (props: FilteredPostsProps) => {
  const { posts, notes, lifeUpdates } = props;
  const [searchValue, setSearchValue] = useState('');
  // const t = useTranslations();

  const filteredPosts = posts.filter((post) =>
    post.title.toLowerCase().includes(searchValue.toLowerCase()),
  );
  const filteredNotes = notes.filter((note) =>
    note.title.toLowerCase().includes(searchValue.toLowerCase()),
  );

  const filteredLifeUpdate = lifeUpdates.filter((note) =>
    note.title.toLowerCase().includes(searchValue.toLowerCase()),
  );

  const ALL_CONTENT = [...posts, ...notes, ...lifeUpdates];
  const ALL_FILTERED_CONTENT = [
    ...filteredNotes,
    ...filteredNotes,
    ...filteredLifeUpdate,
  ];
  const ALL_FILTERED_TAGS = ALL_FILTERED_CONTENT.flatMap((a) => a.tags);

  const ALL_TAGS = ALL_CONTENT.flatMap((a) => a.tags);
  const TagList = countBy(ALL_TAGS);
  const FilteredTagList = countBy(ALL_FILTERED_TAGS);
  const SortedTags = Object.entries(TagList).sort((a, b) => b[1] - a[1]);

  return (
    <div className={'filtered-posts'}>
      <div className={'filtered-post-page-header flex w-full'}>
        <div className="relative mb-8 mx-3 w-full self-start mr-4">
          <Input
            type="text"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            placeholder={'Search articles...'}
            aria-label={'Search articles...'}
            size={'lg'}
            className="w-full pl-12 bg-primary/5"
            id="search"
          />
          <Label htmlFor="search">
            <SearchIcon className="absolute left-4 top-1/2 size-5 -translate-y-1/2" />
          </Label>
        </div>
        <RenderPostsTags tags={SortedTags} filteredTagList={FilteredTagList} />
      </div>
      {filteredPosts.length === 0 ? (
        <div className="my-24 text-center text-xl">{'No Posts Found.'}</div>
      ) : null}

      <PostCards
        posts={filteredPosts}
        notes={filteredNotes}
        lifeUpdates={filteredLifeUpdate}
      />
    </div>
  );
};

export default FilteredPosts;
